// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e8244e11","160":"9cf7564d","453":"130d29ad","558":"479ab593"}[chunkId] + ".chunk.js";
};